module.exports = __webpack_public_path__ + "img/logoIcon.e2eb2d65.svg";